var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import CoreLink from '../CoreLink';
import Menu from '../../Drupal/Entity/Menu';
/* eslint-disable @typescript-eslint/no-unsafe-return */
var Mode = /*#__PURE__*/function (Mode) {
  Mode["full"] = "full";
  Mode["breadcrumb"] = "breadcrumb";
  Mode["intranet"] = "intranet";
  return Mode;
}(Mode || {});
// The default Menu Item component.
// You can overwrite this through the MenuItemElement prop.
var MenuLi = function MenuLi(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", props, children);
};
var RecursiveMenu = function RecursiveMenu(_ref2) {
  var menuId = _ref2.menuId,
    _ref2$minLevel = _ref2.minLevel,
    minLevel = _ref2$minLevel === void 0 ? 1 : _ref2$minLevel,
    _ref2$maxLevel = _ref2.maxLevel,
    maxLevel = _ref2$maxLevel === void 0 ? 10 : _ref2$maxLevel,
    _ref2$mode = _ref2.mode,
    mode = _ref2$mode === void 0 ? Mode.full : _ref2$mode,
    _ref2$MenuItemElement = _ref2.MenuItemElement,
    MenuItemElement = _ref2$MenuItemElement === void 0 ? MenuLi : _ref2$MenuItemElement,
    _ref2$additionalClass = _ref2.additionalClassName,
    additionalClassName = _ref2$additionalClass === void 0 ? '' : _ref2$additionalClass,
    _ref2$onClickFunction = _ref2.onClickFunction,
    onClickFunction = _ref2$onClickFunction === void 0 ? function () {} : _ref2$onClickFunction,
    _ref2$alterUrlFunctio = _ref2.alterUrlFunction,
    alterUrlFunction = _ref2$alterUrlFunctio === void 0 ? function (url) {
      return url;
    } : _ref2$alterUrlFunctio,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  var currentPage = useSelector(function (state) {
    return state.getIn(['router', 'location', 'pathname'], '');
  });
  var RecursiveMenuClassnames = c('RecursiveMenu', className);

  // buildMenu is a recursive function to render a full menu tree.
  var buildMenu = function buildMenu(item, parentIsActive, parentIsActiveOrTrail) {
    var _item$link$options, _item$link$options$at;
    var _item$link = item.link,
      title = _item$link.title,
      url = _item$link.url,
      description = _item$link.description;
    var itemClassNames = (_item$link$options = item.link.options) === null || _item$link$options === void 0 ? void 0 : (_item$link$options$at = _item$link$options.attributes) === null || _item$link$options$at === void 0 ? void 0 : _item$link$options$at.class;
    var active = item.link.url === currentPage;
    var trail = currentPage.startsWith(item.link.url) && !(item.link.url === currentPage);
    var RecursiveMenuItemClassnames = c('RecursiveMenu__item', {
      'RecursiveMenu__item--active': active
    }, {
      'RecursiveMenu__item--trail': trail
    }, additionalClassName, itemClassNames);

    // minLevel allows us to skip rendering an x amount of layers.
    // We go straight to the next layer, withouth rendering anything.
    if (minLevel > 0 && item.depth < minLevel) {
      return item.subtree.map(function (_item) {
        return buildMenu(_item, mode === Mode.breadcrumb ? active : undefined, mode === Mode.intranet ? active || trail : undefined);
      });
    }

    // Breadcrumb mode
    // Only render the current tree we're on, and the children of the active node.
    // Almost like breadcrumbs, but also show the upcoming crumbs.
    if (mode === Mode.breadcrumb && !parentIsActive && !active && !trail) {
      return null;
    }

    // Intranet mode
    // If the current node's parent is not the active page or in trail, don't render.
    if (mode === Mode.intranet && parentIsActiveOrTrail === false) {
      return null;
    }

    // The default return renders our MenuItem and renders any possible children, recursively.
    return /*#__PURE__*/React.createElement(MenuItemElement, {
      data: item.link.title,
      className: RecursiveMenuItemClassnames
    }, /*#__PURE__*/React.createElement(React.Fragment, null, url ? /*#__PURE__*/React.createElement(CoreLink, {
      title: title,
      className: "RecursiveMenu__title haslink",
      href: alterUrlFunction(url),
      onClick: function onClick() {
        return onClickFunction(false);
      }
    }, /*#__PURE__*/React.createElement("span", null, title)) : /*#__PURE__*/React.createElement("span", {
      className: "RecursiveMenu__title nolink"
    }, title), description && /*#__PURE__*/React.createElement("div", {
      className: "RecursiveMenu__description"
    }, description), item.has_children && !(item.depth >= maxLevel) && /*#__PURE__*/React.createElement("ul", {
      className: "RecursiveMenu__layer__".concat(item.depth - (minLevel ? minLevel - 1 : 0))
    }, item.subtree.map(function (_item) {
      return buildMenu(_item, mode === Mode.breadcrumb ? active : undefined, mode === Mode.intranet ? active || trail : undefined);
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: RecursiveMenuClassnames
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(Menu, {
    id: menuId
  }, function (items) {
    return /*#__PURE__*/React.createElement("ul", {
      className: "RecursiveMenu__layer__0"
    }, items.toJS().map(function (item) {
      return buildMenu(item);
    }));
  })));
};
export default RecursiveMenu;